import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Header, StyledContentBlock, StyledSection } from './styled';
import BuySellTrade from '../BuySellTrade';
import Security from '../Security';

import Markets from '../Markets';

import MoveMoney from '../MoveMoney/MoveMoney';
import MobileWallet from '../MobileWallet';
import Connect from '../Connect';

const Features = ({ template }) => {
  const { messages, locale } = useIntl();
  const isERC20Token =
    template !== 'bitcoin' &&
    template !== 'bitcoin-cash' &&
    template !== 'zano';
  return (
    <>
      <StyledSection>
        <StyledContentBlock>
          <Header locale={locale}>
            {messages[`${template}.buy-sell-trade.header`]}
          </Header>
        </StyledContentBlock>
      </StyledSection>
      <MobileWallet template={template} />
      <Security template={template} />
      {template !== 'bitcoin-cash' && template !== 'zano' && (
        <MoveMoney template={template} />
      )}
      {isERC20Token && <Connect template={template} />}
      <BuySellTrade template={template} />
      <Markets template={template} />
    </>
  );
};
Features.propTypes = {
  template: PropTypes.string.isRequired,
};

export default Features;
